import ApiService from '@/services/core/api.service'

const CommentService = {
  async get (payment, params = {}) {
    return ApiService.get(`financial-operation-manager/payment-approvals/${payment}/comments`, { params })
  },

  async post (payment, payload) {
    return ApiService.post(`financial-operation-manager/payment-approvals/${payment}/comments`, payload)
  },

  async put (payment, payload) {
    return ApiService.put(`financial-operation-manager/payment-approvals/${payment}/comments/${payload.id}`, payload)
  },

  async delete (payment, payload) {
    return ApiService.delete(`financial-operation-manager/payment-approvals/${payment}/comments/${payload.id}`, {
      data: payload
    })
  }
}

export default CommentService
